import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";
import { UnifiedDatePicker, UnifiedDatePickerProps } from "./unified-date-picker";
import { useTranslateMessage } from "@/hooks/useTranslateMessage";

interface ControlledUnifiedDatePickerProps<T extends FieldValues>
  extends Omit<UnifiedDatePickerProps, "value" | "onChange" | "error" | "id"> {
  name: Path<T>;
  control: Control<T>;
  defaultValue?: PathValue<T, Path<T>>;
}

export const ControlledUnifiedDatePicker = <T extends FieldValues>({
  control,
  name,
  defaultValue,
  ...pickerProps
}: ControlledUnifiedDatePickerProps<T>) => {
  const translateMessage = useTranslateMessage();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <UnifiedDatePicker
          {...pickerProps}
          id={name}
          value={field.value}
          onChange={field.onChange}
          ref={field.ref}
          error={translateMessage(error?.message)}
        />
      )}
    />
  );
};
